import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import logo from "../../assets/images/logo.png"
import rgit_logo from "../../assets/images/rgit.png"
import { Badge, Box, MenuItem, Select, Stack, TextField } from "@mui/material"
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded"
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded"
import { Link } from "react-router-dom"
import routes from "../../constants/routes"
import { NotificationsCard } from "./NotificationsCard"
import { getNotificationsUnread } from "../../api"
import FormItem from "../ui/FormItem"
import React, { useState, useEffect, useRef } from "react"
import {
  GroupsRounded,
  AddHomeWorkRounded,
  HomeRounded,
} from "@mui/icons-material"

const options = [
  {value: "Home", icon: <HomeRounded />},
  {value: "RGIT", logo: rgit_logo},
]

const Navbar = () => {
  // for notif popover menu
  const [open, setOpen] = useState(false)
  const [organisation, setOrganisation] = useState("Home")
  const anchorRef = useRef(null)
  const handleToggle = () => setOpen(!open)
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return
    setOpen(false)
  }
  const [unread, setUnread] = useState(0)
  const fetchUnread = () => {
    getNotificationsUnread()
      .then((res) => {
        setUnread(res.data?.unread)
      })
      .catch((err) => console.log(err))
  }
  useEffect(() => {
    fetchUnread()
  }, [])

  const handleChange = (event) => {
    const { name, value } = event.target
    setOrganisation(value)
  }

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#fff",
        borderBottom: "solid 2px rgba(0,0,0,0.1)",
        width: "100%",
        zIndex: "1000",
      }}
    >
      <Toolbar sx={{ minHeight: 40, px: 1 }} disableGutters>
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems="center"
          spacing={2}
          sx={{ width: "100%" }}
        >
          <Stack direction="row" alignItems={"center"} spacing={2}>
            <Link
              to={"/"}
            >
              <img src={logo} alt="youstad_logo" style={{ height: "2.3rem" }} />
            </Link>
            <Select
              name="organisation"
              value={organisation}
              onChange={handleChange}
              sx={{
                height: "2.3rem",
                width: "12rem",
                borderColor: "transparent",
              }}
            >
              {options.map((c) => (
                <MenuItem value={c.value}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    style={{ color: "gray", fontSize: "small" }}
                    gap={1}
                  >
                    {c.icon ? c.icon : <img src={c.logo} style={{ height: "1.5rem"}} />} {c.value}
                  </Stack>
                </MenuItem>
              ))}
              <Link
                to={"/register"}
              >
                <MenuItem value="New Academy">
                  <Stack
                    direction="row"
                    alignItems="center"
                    style={{ color: "gray", fontSize: "small" }}
                    gap={1}
                  >
                    <AddHomeWorkRounded /> New Academy
                  </Stack>
                </MenuItem>
              </Link>
            </Select>
          </Stack>
          <Stack
            direction="row"
            alignItems={"center"}
            spacing={2}
            sx={{ pr: "20px", mt: "5px !important" }}
          >
            <Box
              sx={{
                display: {
                  xs: "none",
                  lg: "block",
                },
              }}
            >
              <Link to={routes.CALENDAR}>
                <IconButton>
                  <CalendarMonthRoundedIcon
                    color="primary"
                    sx={{ fontSize: "1.8rem" }}
                  />
                </IconButton>
              </Link>
            </Box>

            <IconButton>
              <Badge max={99} badgeContent={unread} color="primary">
                <NotificationsRoundedIcon
                  ref={anchorRef}
                  id="composition-button"
                  aria-controls={open ? "composition-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleToggle}
                  color="primary"
                  sx={{ fontSize: "1.8rem" }}
                />
              </Badge>
            </IconButton>
            <NotificationsCard
              open={open}
              handleClose={handleClose}
              anchorRef={anchorRef}
            />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  )
}

export default Navbar
